export const generateKPIDetails = ({
  kpiDetails,
  filteredData,
  alertType,
  customCounters = {},
  orLossTreeKPIData,
}) => {
  const kpiObj = kpiDetails?.map((kpi) => ({ ...kpi }));

  
  if (!kpiObj) return [];

  const alertHandlers = {
    "Or Loss Tree": (orLossTreeKPIData, kpiObj) => {
      const map = {
        "OR%": { valueKey: "OR_Percentage", changeKey: "OR_Percentage_Change" },
        "Production Plan": { valueKey: "ProductionPlan", changeKey: "ProductionPlan_Change" },
        "OR Loss": { valueKey: "OR_Loss", changeKey: "OR_Loss_Change" }
      };

      kpiObj.forEach((item) => {
        const config = map[item.label];
        if (config) {
          const valueRaw = orLossTreeKPIData?.[config.valueKey];
          const changeRaw = orLossTreeKPIData?.[config.changeKey];

          item.value = config.valueKey.includes("Percentage")
            ? parseFloat(valueRaw || 0).toFixed(1)
            : parseFloat(valueRaw || 0).toLocaleString();

          item.delta = parseFloat(changeRaw || 0).toFixed(2);
        }
      });
    },
  };

  // ✅ Proper handler call
  if (alertType === "Or Loss Tree") {
    alertHandlers["Or Loss Tree"](orLossTreeKPIData, kpiObj);
  } else if (alertHandlers[alertType]) {
    alertHandlers[alertType](filteredData);
  }

  Object.entries(customCounters).forEach(([key, value]) => {
    const kpiIndex = kpiObj.findIndex((item) => item.label === key);
    if (kpiIndex !== -1) {
      kpiObj[kpiIndex].value = value;
    }
  });

  return kpiObj;
};
